<template>
  <div class="footer">
    <div class="copyright-wrapper">
      <p>
        Copyright © 2025-{{ new Date().getFullYear() }} 北京点金未来科技有限公司
        版权所有&nbsp;|&nbsp;
        <a href="https://beian.miit.gov.cn/#/Integrated/index" rel="noreferrer"
           target="_blank">京ICP备2025103342号-4</a>
        &nbsp;|&nbsp;
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=11010802045630" rel="noreferrer" target="_blank">
          <img src="@/assets/png/copyright_icon.png" alt="">
          京公网安备11010802045630号
        </a>&nbsp;|&nbsp;
        <a href="https://beian.miit.gov.cn/#/Integrated/index" rel="noreferrer" target="_blank">
          增值电信业务经营许可证：京B2-20251403
        </a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      company: "Copyright © 2025-2025 北京点金未来科技有限公司 版权所有",
      companyBA: "备案号:京ICP备2025103342号-4",
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.footer {
  height: 100%;
  width: 100%;
  // background: #f5f5f5;
  text-align: center;
  .copyright-wrapper {
    color: #717274;
    padding: 10px;
    font-size: 14px;
    img {
      vertical-align: bottom;
    }
    a {
      color: #717274 !important;
      text-decoration: none;
      &:hover {
        color: #717274 !important;
      }
    }
  }
}
</style>
